import { createMultiStyleConfigHelpers, } from "@chakra-ui/styled-system";
import { textStyles } from "../../../../theme/foundations/generated";
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers([
    "mainContainer",
    "textsAndActionsContainer",
    "actionsContainer",
    "textsContainer",
    "title",
    "description",
    "leftIcon",
    "badge",
    "closeAndBadgeContainer",
]);
const baseStyle = definePartsStyle(() => ({
    mainContainer: {
        width: "100%",
        padding: "1rem",
        paddingY: "0.6875rem",
        display: "flex",
        gap: "1rem",
    },
    actionsContainer: {
        display: "flex",
        gap: "1rem",
    },
    textsAndActionsContainer: {
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        height: "auto",
        alignItems: "center",
    },
    textsContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "auto",
    },
    title: Object.assign({}, textStyles.body.largeXbold),
    description: Object.assign({}, textStyles.body.mediumDemibold),
    closeAndBadgeContainer: {
        display: "flex",
        justifyContent: "flex-start",
        gap: "0.5rem",
        flexDirection: "column",
        alignItems: "center",
    },
    leftIcon: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
    },
    badge: Object.assign({}, textStyles.body.mediumDemibold),
}));
const variants = {
    interactiveError: definePartsStyle(({ size }) => ({
        mainContainer: {
            backgroundColor: "semantic.background.error",
            color: "semantic.icon.error",
            borderColor: "semantic.border.error",
        },
        textsAndActionsContainer: Object.assign({}, (size === "mobile"
            ? {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
            }
            : {})),
        leftIcon: Object.assign({ color: "semantic.icon.error" }, (size === "mobile" ? { justifyContent: "flex-start" } : {})),
    })),
    passiveError: definePartsStyle(({ size }) => ({
        mainContainer: Object.assign({ backgroundColor: "semantic.background.error", color: "semantic.icon.error", borderColor: "semantic.border.error" }, (size === "desktop"
            ? { borderWidth: "1px", borderStyle: "solid" }
            : {})),
        leftIcon: {
            color: "semantic.icon.error",
        },
    })),
    interactiveSuccess: definePartsStyle(({ size }) => ({
        mainContainer: {
            backgroundColor: "semantic.background.success",
            color: "semantic.text.success",
            borderColor: "semantic.border.shipped",
        },
        textsAndActionsContainer: Object.assign({}, (size === "mobile"
            ? {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
            }
            : {})),
        leftIcon: Object.assign({ color: "semantic.icon.success" }, (size === "mobile" ? { justifyContent: "flex-start" } : {})),
    })),
    passiveSuccess: definePartsStyle(({ size }) => ({
        mainContainer: Object.assign({ backgroundColor: "semantic.background.success", color: "semantic.text.success", borderColor: "semantic.border.shipped" }, (size === "desktop"
            ? { borderWidth: "1px", borderStyle: "solid" }
            : {})),
        leftIcon: {
            color: "semantic.icon.success",
        },
    })),
    interactiveWarning: definePartsStyle(({ size }) => ({
        mainContainer: {
            backgroundColor: "semantic.background.warning",
            color: "semantic.text.warning",
            borderColor: "semantic.border.inprogress",
        },
        textsAndActionsContainer: Object.assign({}, (size === "mobile"
            ? {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
            }
            : {})),
        leftIcon: Object.assign({ color: "semantic.icon.warning" }, (size === "mobile" ? { justifyContent: "flex-start" } : {})),
    })),
    passiveWarning: definePartsStyle(({ size }) => ({
        mainContainer: Object.assign({ backgroundColor: "semantic.background.warning", color: "semantic.text.warning", borderColor: "semantic.border.inprogress" }, (size === "desktop"
            ? { borderWidth: "1px", borderStyle: "solid" }
            : {})),
        leftIcon: {
            color: "semantic.icon.warning",
        },
    })),
    interactiveInformation: definePartsStyle(({ size }) => ({
        mainContainer: {
            backgroundColor: "semantic.background.info",
            color: "semantic.text.info",
            borderColor: "semantic.border.created",
        },
        textsAndActionsContainer: Object.assign({}, (size === "mobile"
            ? {
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "1rem",
            }
            : {})),
        leftIcon: Object.assign({ color: "semantic.icon.info" }, (size === "mobile" ? { justifyContent: "flex-start" } : {})),
    })),
    passiveInformation: definePartsStyle(({ size }) => ({
        mainContainer: Object.assign({ backgroundColor: "semantic.background.info", color: "semantic.text.info", borderColor: "semantic.border.created" }, (size === "desktop"
            ? { borderWidth: "1px", borderStyle: "solid" }
            : {})),
        leftIcon: {
            color: "semantic.icon.info",
        },
    })),
    subheaderSuccess: definePartsStyle({
        mainContainer: {
            backgroundColor: "semantic.background.success",
            color: "semantic.text.success",
            borderWidth: 0,
        },
        textsAndActionsContainer: {
            justifyContent: "center",
        },
        description: Object.assign(Object.assign({}, textStyles.body.largeDemibold), { textAlign: "center" }),
    }),
    subheaderError: definePartsStyle({
        mainContainer: {
            backgroundColor: "semantic.background.error",
            color: "semantic.icon.error",
            borderWidth: 0,
        },
        textsAndActionsContainer: {
            justifyContent: "center",
        },
        description: Object.assign(Object.assign({}, textStyles.body.largeDemibold), { textAlign: "center" }),
    }),
};
const sizes = {
    desktop: definePartsStyle({}),
    mobile: definePartsStyle({}),
};
const NotificationTheme = defineMultiStyleConfig({
    baseStyle,
    variants,
    sizes,
    defaultProps: {
        variant: "passiveInformation",
        size: "desktop",
    },
});
export default NotificationTheme;
//# sourceMappingURL=Notification.default.js.map